import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useCheckAlwaysAllowLocationSettingIsEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.CHECK_ALWAYS_ALLOW_LOCATION_SETTING, {
    defaultValue: false,
  });
}
